import React from 'react';
import styled from '@emotion/styled';
import { Box, Grid, Typography } from '@mui/material';
import { OrderJobAsset } from '../../../redux/slices/slice_types';
import AssetIcon from '../../Job/JobTabs/JobTabAssetStatus/AssetIcon';
import { selectBaseLanguages } from '@/redux/selectors/constantsSelectors';
import { useAppSelector } from '@/redux/hooks';

interface PendingAssetDisplayProps {
  pendingAsset: OrderJobAsset;
}

const PendingAssetDisplay = ({ pendingAsset }: PendingAssetDisplayProps) => {
  const Languages = useAppSelector(selectBaseLanguages);
  const fileType = pendingAsset.filename && pendingAsset.filename.split('.').pop();
  const langCode: any = pendingAsset.subtitle_language || pendingAsset.audio_language;
  const language = Languages?.find((l) => l.code === langCode)?.label || langCode;

  return (
    <PendingAssetBox>
      <Grid container alignItems="center" flexWrap="nowrap">
        <AssetIcon type={fileType} withColor />
        <Grid item sx={{ ml: 1 }}>
          <PendingAssetTypography variant="h3">{pendingAsset.filename}</PendingAssetTypography>
          <Typography variant="caption">{pendingAsset.s3_bucket}</Typography>
        </Grid>
        <Typography sx={{ ml: 'auto' }}>{language}</Typography>
      </Grid>
    </PendingAssetBox>
  );
};

export default PendingAssetDisplay;

const PendingAssetBox = styled(Box)`
  ${({ theme }) => `  
  background-color: ${theme.palette.default.main}20;
  border: 2px dashed ${theme.palette.default.main}80;
  border-radius: ${theme.shape.borderRadius}px;
  padding: ${theme.spacing(2.5, 2)};

  .MuiDivider-root {
    margin: ${theme.spacing(2)} 0;
  }
  `}
`;

const PendingAssetTypography = styled(Typography)`
  font-size: 1.2rem;
`;
